import React from "react";

const TextBlock = ({ title, description }) => (
  <div className="tw-flex tw-flex-col tw-gap-1 tw-text-gray-950">
    <span className="tw-font-medium">{title}</span>
    <span className="tw-font-regular tw-text-xs">{description}</span>
  </div>
);

export default TextBlock;
